export const CaretIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="11" height="6" viewBox="0 0 11 6" fill="none">
		<path
			d="M9.19922 1.18176L5.19922 4.81813L1.19922 1.18176"
			stroke="#FFFFFF"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
